import * as React from "react";
import PropTypes from "prop-types";
import { useAppSelector } from "../../../../app/store";
import style from "./style.module.css";
import reducerPath from "../../../../app/reducerPath";

function FieldHarvesterStatuses({ ids }) {
  const {
    stateData: initialState,
  } = useAppSelector((state) => state[`${reducerPath.logisticTasksBalanceResource}/counter`]);
  const socketLogistic = useAppSelector((state) => state.stateLogisticTasksResource);
  const states = React.useMemo(() => (socketLogistic?.producerStates ? {
    ...socketLogistic.producerStates,
  } : {
    ...(initialState?.stateMap?.producerStates || {}),
  }), [initialState, socketLogistic]);

  const activeHarvesters = React.useMemo(() => (states
    ? Object.keys(states)?.reduce((acc, key) => {
      if (ids?.includes(+key)) {
        acc.push(states[key]);
      }
      return acc;
    }, [])
    : []
  ), [ids, states]);

  const error = activeHarvesters.filter((e) => e?.state === "ERROR")?.length;
  const stopped = activeHarvesters.filter(
    (e) => e?.state === "STOPPED"
  )?.length;
  const running = activeHarvesters.filter(
    (e) => e?.state === "RUNNING"
  )?.length;

  return (
    <div className={style.table}>
      <div className={style.tableRow}>
        {error > 0 && (
          <div className={style.tableCell} title="Ошибка">
            О
          </div>
        )}
        {running > 0 && (
          <div className={style.tableCell} title="Движение">
            Д
          </div>
        )}
        {stopped > 0 && (
          <div className={style.tableCell} title="Стоп">
            С
          </div>
        )}
      </div>
      <div className={style.tableRow}>
        {error > 0 && (
          <div
            className={`${style.tableCell} ${style.errorColor}`}
            title="Ошибка"
          >
            {error}
          </div>
        )}
        {running > 0 && (
          <div
            className={`${style.tableCell} ${style.runningColor}`}
            title="Движение"
          >
            {running}
          </div>
        )}
        {stopped > 0 && (
          <div
            className={`${style.tableCell} ${style.stoppedColor}`}
            title="Стоп"
          >
            {stopped}
          </div>
        )}
      </div>
    </div>
  );
}

FieldHarvesterStatuses.propTypes = {
  ids: PropTypes.arrayOf(PropTypes.number).isRequired,
};

export default FieldHarvesterStatuses;
